<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="4" :sm="8">
            <a-form-item label="真实名字">
              <!-- <j-input placeholder="请输入真实名字" v-model="queryParam.realname"></j-input> -->
               <a-input placeholder="请输入真实名字查询" v-model="queryParam.realname"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="账号">
              <a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>
              <!-- <j-input placeholder="输入账号模糊查询" v-model="queryParam.username"></j-input> -->
            </a-form-item>
          </a-col>
        
          <a-col :md="4" :sm="8">
            <a-form-item label="年度审核">
              <a-select v-model="queryParam.isApproved" placeholder="请选择">
                <a-select-option value="1">未审核</a-select-option>
                <a-select-option value="2">审核通过</a-select-option>
                <a-select-option value="3">审核未通过</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
       

          <a-col :md="7" :sm="12">
            <a-form-item label="审核状态">
              <j-dict-select-tag
                dict-code="user_statusing"
                v-model="queryParam.statusing"
                placeholder="请选择审核状态"
                type="radio"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="4" :sm="8">
              <a-form-item label="手机号码">
                <a-input placeholder="请输入手机号码查询" v-model="queryParam.phone"></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="4" :sm="8">
              <a-form-item label="用户状态">
                <a-select v-model="queryParam.status" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">正常</a-select-option>
                  <a-select-option value="2">冻结</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="8">
              <a-form-item label="所属乡镇">
                <j-dict-select-tag
                  dict-code="town_beef"
                  v-model="queryParam.townshipId"
                  placeholder="请选择负责乡镇"
                  type="select"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus">添加用户</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('养殖户信息')">导出</a-button>
      <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"-->
      <!--                @change="handleImportExcel">-->
      <!--        <a-button type="primary" icon="import">导入</a-button>-->
      <!--      </a-upload>-->
      <!--      <j-third-app-button biz-type="user" :selected-row-keys="selectedRowKeys" syncToApp syncToLocal-->
      <!--                          @sync-finally="onSyncFinally"/>-->
      <a-button type="primary" icon="hdd" @click="recycleBinVisible = true">回收站</a-button>
      <a-button type="primary" :disabled="!selectedRowKeys.length" icon="hdd" @click="handleApproved('all')"
        >年度审核</a-button
      >

      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <!-- <a-menu-item key="0">
            <a-icon type="check-circle" @click="checkBatch" />
            审核
          </a-menu-item> -->
          <!-- <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel" />
            删除
          </a-menu-item> -->
          <a-menu-item key="2">
            <a-icon type="lock" @click="batchFrozen('2')" />
            冻结
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="unlock" @click="batchFrozen('1')" />
            解冻
          </a-menu-item>
          <!-- <a-menu-item key="4"> <a-icon type="check-circle" @click="handleApproved('all')" /> 是否审核 </a-menu-item> -->
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <!--      <j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery"/>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{
          selectedRowKeys.length
        }}</a
        >项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        :scroll="{ x: true }"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />
          </div>
        </template>

        <template slot="beefA" slot-scope="text, record">
          <a-tooltip>
            {{ text }}
            <a-button icon="search" type="primary" size="small" @click="showBeef(record, 'A')"></a-button>
            <template slot="title">
              只统计终审通过的牛犊数
            </template>
          </a-tooltip>
        </template>
        <template slot="beefB" slot-scope="text, record">
          <a-tooltip>
            {{ record.newCalf }}
            <a-button icon="search" type="primary" size="small" @click="showBeefCalf(record, 'B')"></a-button>
            <template slot="title">
              只统计终审通过的牛犊数
            </template>
          </a-tooltip>
        </template>

        <span slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" @click="showModelTag(record)">分配耳标</a-button>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">修改</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleApproved('one', record)">年度审核</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>

              <a-menu-item>
                <a href="javascript:;" @click="handleChangePassword(record.username)">密码</a>
              </a-menu-item>

              <!-- <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item> -->

              <a-menu-item v-if="record.status == 1">
                <a-popconfirm title="确定冻结吗?" @confirm="() => handleFrozen(record.id, 2, record.username)">
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status == 2">
                <a-popconfirm title="确定解冻吗?" @confirm="() => handleFrozen(record.id, 1, record.username)">
                  <a>解冻</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk" />

    <a-modal v-model="visibleBeefList" title="基础母牛列表" @ok="visibleBeefList = false" width="80%">
      <beef-cattle-list ref="beefCattle"></beef-cattle-list>
    </a-modal>
    <a-modal v-model="visibleBeefCalfList" title="犊牛列表" @ok="visibleBeefCalfList = false" width="80%">
      <beef-cattle-small-list2 :defaultYear="queryParam.year" ref="beefCattleCalf"></beef-cattle-small-list2>
    </a-modal>

    <a-modal v-model="visibleTags" title="养殖户耳标分配" @ok="handleTagOk" width="800px" :confirm-loading="loadingTag">
      <div style="color: red;">编辑完成后请点击确认保存</div>
      <a-card>
        <a-button
          type="primary"
          icon="plus"
          @click="
            () => {
              tagsUserList.push({ tagsNumberStart: null, tagsNumberEnd: null, id: new Date().getTime() })
            }
          "
          >添加
        </a-button>
        <a-table
          :columns="columnsTag"
          :scroll="{ x: true }"
          :data-source="tagsUserList"
          bordered
          rowKey="id"
          style="margin-top: 10px"
          :loading="loadingTag"
        >
          <template slot="tagsNumberStart" slot-scope="text, record">
            <div style="display: flex;align-items: center">
              <a-input
                placeholder="请输入"
                v-model="record.tagsNumberStart"
                :maxLength="15"
                style="width: 80%"
              ></a-input>
              <span v-if="null != record.tagsNumberStart && undefined !== record.tagsNumberStart"
                >{{ (record.tagsNumberStart + '').length }}位</span
              >
            </div>
            <!--            <a-select show-search style="width: 100%" placeholder="请分配可用耳标编号起" v-model="record.tagsNumberStart">-->
            <!--              <a-select-option v-for="i in maxTagsNumber" :key="372324100000000+i">-->
            <!--                {{372324100000000+i}}-->
            <!--              </a-select-option>-->
            <!--            </a-select>-->
          </template>
          <template slot="tagsNumberEnd" slot-scope="text, record">
            <div style="display: flex;align-items: center">
              <a-input
                placeholder="请请输入"
                v-model="record.tagsNumberEnd"
                :maxLength="15"
                style="width: 80%"
              ></a-input>
              <span v-if="null != record.tagsNumberEnd && undefined !== record.tagsNumberEnd"
                >{{ (record.tagsNumberEnd + '').length }}位</span
              >
            </div>
            <!--            <a-select show-search style="width: 100%" placeholder="请分配可用耳标编号止" v-model="record.tagsNumberEnd">-->
            <!--              <a-select-option v-for="i in maxTagsNumber" :key="372324100000000+i">-->
            <!--                {{372324100000000+i}}-->
            <!--              </a-select-option>-->
            <!--            </a-select>-->
          </template>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm
              title="确定删除吗?"
              @confirm="
                () => {
                  tagsUserList = tagsUserList.filter(tagsUser => {
                    return tagsUser.id != record.id
                  })
                }
              "
            >
              <a>删除</a>
            </a-popconfirm>
          </span>
        </a-table>
      </a-card>
    </a-modal>
    <a-modal
      v-model="visibleCheck"
      :title="'共 ' + checkUserRows.length + ' 人，是否通过审核'"
      @ok="handleCheckBatchOk"
      width="80%"
      :confirm-loading="loadingTag"
    >
      <a-table
        :columns="columnsCheck"
        :scroll="{ x: true }"
        :data-source="checkUserRows"
        bordered
        rowKey="id"
        style="margin-top: 10px"
        :loading="loadingTag"
      >
        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />
          </div>
        </template>
      </a-table>
      <template slot="footer">
        <a-button @click="visibleCheck = false">取消</a-button>
        <a-button @click="handleCheckBatchNo" type="danger">驳回</a-button>
        <a-button @click="handleCheckBatchOk" type="primary">通过</a-button>
      </template>
    </a-modal>
    <a-modal v-model="visibleCheckNo" title="确认驳回吗" @ok="checkPost('6')">
      <a-input type="textarea" v-model="checkRemark" placeholder="请输入驳回原因"></a-input>
    </a-modal>

    <a-modal v-model="approveddialg" title="确认审批吗" @ok="checkPut()">
      <a-radio-group v-model="isApproved">
        <a-radio :value="2">
          通过
        </a-radio>
        <a-radio :value="3">
          不通过
        </a-radio>
      </a-radio-group>
    </a-modal>

    <!-- <a-modal v-model="editdialg" title="修改" @ok="newedit">
      <a-form :form="record" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" >
        <a-form-item label="Note">
          <a-input v-decorator="['note', { rules: [{ required: true, message: 'Please input your note!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal> -->
  </a-card>
</template>

<script>
import UserModal from './modules/UserBreedModal'
import PasswordModal from './modules/PasswordModal'
import { getFileAccessHttpUrl, getAction, postAction, putAction1 } from '@/api/manage'
import { frozenBatch } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SysUserAgentModal from './modules/SysUserAgentModal'
import JInput from '@/components/jeecg/JInput'
import UserRecycleBinModal from './modules/UserRecycleBinModal'
import JSuperQuery from '@/components/jeecg/JSuperQuery'
import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'
import BeefCattleList from '../beef/BeefCattleList2023'
import BeefCattleSmallList2 from '../beef/BeefCattleSmallList2'

export default {
  name: 'UserBreedList',
  mixins: [JeecgListMixin],
  components: {
    BeefCattleSmallList2,
    BeefCattleList,
    JThirdAppButton,
    SysUserAgentModal,
    UserModal,
    PasswordModal,
    JInput,
    UserRecycleBinModal,
    JSuperQuery
  },
  data() {
    return {
      description: '这是用户管理页面',
      editdialg: false,
      queryParam: {
        year: '2023'
      },
      approveddialg: false,
      isApproved: 2,
      record: {},
      selectedRowKeys: [],
      recycleBinVisible: false,
      visibleTags: false,
      visibleBeefList: false,
      visibleBeefCalfList: false,
      columns: [
        /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
        // {
        //   title: '用户账号',
        //   align: 'center',
        //   dataIndex: 'username',
        //   width: 120,
        //   sorter: true
        // },
        {
          title: '头像',
          align: 'center',
          width: 120,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot' }
        },
        {
          title: '用户姓名',
          align: 'center',
          width: 100,
          dataIndex: 'realname'
        },
        {
          title: '养殖场名称',
          align: 'center',
          width: 100,
          dataIndex: 'farmName'
        },

        {
          title: '手机号码',
          align: 'center',
          width: 100,
          dataIndex: 'phone'
        },
        {
          title: '所在乡镇',
          align: 'center',
          width: 100,
          dataIndex: 'townshipName'
        },
        {
          title: '开户行',
          align: 'center',
          width: 100,
          dataIndex: 'bankDeposit'
        },
        {
          title: '银行账号',
          align: 'center',
          width: 100,
          dataIndex: 'bankAccount'
        },

        {
          title: '状态',
          align: 'center',
          width: 80,
          dataIndex: 'status_dictText'
        },
        {
          title: '年度审核',
          align: 'center',
          width: 80,
          dataIndex: 'isApproved',
          customRender: (text, record) => {
            const num = Number(record.isApproved)
            return ['未审核','审核通过','审核驳回'][num - 1]
            // if (record.isApproved == 1) {
            //   return '否'
            // } else {
            //   return '是'
            // }
          }
        },
        {
          title: '审核状态',
          align: 'center',
          width: 80,
          dataIndex: 'statusing_dictText'
        },

        {
          title: '基础母牛',
          align: 'center',
          width: 100,
          dataIndex: 'beefA'
          // scopedSlots: { customRender: 'beefA' }
        },
        {
          title: '上报母牛',
          align: 'center',
          width: 100,
          dataIndex: 'beefAN',
          scopedSlots: { customRender: 'beefA' }
        },
        // {
        //   title: '犊牛',
        //   align: 'center',
        //   width: 100,
        //   dataIndex: 'beefB'
        //   // scopedSlots: { customRender: 'beefB' }
        // },
        {
          title: '新增犊牛',
          align: 'center',
          width: 100,
          dataIndex: 'newCalf1',
          scopedSlots: { customRender: 'beefB' }
        },
        {
          title: '总存栏',
          align: 'center',
          width: 100,
          dataIndex: 'newCalf',
          customRender: (text, record) => {
            if (!record.beefA) {
              record.beefA = 0
            }
            if (!record.beefB) {
              record.beefB = 0
            }
            if (!record.newCalf) {
              record.newCalf = 0
            }
            return record.newCalf + record.beefB + record.beefA
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 170
        }
      ],
      columnsCheck: [
        /*{
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },*/
        // {
        //   title: '用户账号',
        //   align: 'center',
        //   dataIndex: 'username',
        //   width: 120,
        //   sorter: true
        // },
        {
          title: '头像',
          align: 'center',
          width: 120,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot' }
        },
        {
          title: '用户姓名',
          align: 'center',
          width: 100,
          dataIndex: 'realname'
        },
        {
          title: '养殖场名称',
          align: 'center',
          width: 100,
          dataIndex: 'farmName'
        },

        {
          title: '手机号码',
          align: 'center',
          width: 100,
          dataIndex: 'phone'
        },
        {
          title: '所在乡镇',
          align: 'center',
          width: 100,
          dataIndex: 'townshipName'
        },
        {
          title: '开户行',
          align: 'center',
          width: 100,
          dataIndex: 'bankDeposit'
        },
        {
          title: '银行账号',
          align: 'center',
          width: 100,
          dataIndex: 'bankAccount'
        },

        {
          title: '状态',
          align: 'center',
          width: 80,
          dataIndex: 'status_dictText'
        },
        {
          title: '审核状态',
          align: 'center',
          width: 80,
          dataIndex: 'statusing_dictText'
        }

        // {
        //   title: '基础母牛',
        //   align: 'center',
        //   width: 100,
        //   dataIndex: 'beefA',
        //   scopedSlots: { customRender: 'beefA' }
        // },
        // {
        //   title: '犊牛',
        //   align: 'center',
        //   width: 100,
        //   dataIndex: 'beefB',
        //   scopedSlots: { customRender: 'beefB' }
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action' },
        //   align: 'center',
        //   width: 170
        // }
      ],
      superQueryFieldList: [
        { type: 'input', value: 'username', text: '用户账号' },
        { type: 'input', value: 'realname', text: '用户姓名' },
        { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' }
      ],
      url: {
        syncUser: '/act/process/extActProcess/doSyncUser',
        list: '/sys/user/listYzh',
        count: '/beef/beefTags/count',
        userTagList: '/beef/beefTagsUser/userTagList',
        addBatch: '/beef/beefTagsUser/addBatch',
        delete: '/sys/user/delete',
        deleteBatch: '/sys/user/deleteBatch',
        exportXlsUrl: '/sys/user/exportTourXls',
        importExcelUrl: 'sys/user/importExcel',
        batchCheck: 'sys/user/batchCheck',
        isApproved: 'sys/user/approvedNew'
      },
      columnsTag: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '可用耳标编号起',
          dataIndex: 'tagsNumberStart',
          scopedSlots: { customRender: 'tagsNumberStart' }
        },
        {
          title: '可用耳标编号止',
          dataIndex: 'tagsNumberEnd',
          scopedSlots: { customRender: 'tagsNumberEnd' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 170
        }
      ],
      tagsUser: '',
      tagsUserList: [],
      maxTagsNumber: 0,
      baseTag: '372324100',
      loadingTag: false,
      visibleCheck: false,
      checkUserRows: [],
      checkRemark: '',
      visibleCheckNo: false,
      //单个审批
      isoneapproved: true
    }
  },
  created() {
    getAction(this.url.count).then(res => {
      this.maxTagsNumber = res.result
    })
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    newedit() {},
    handleEdit1(record) {
      Object.assign(this.record, record)
      this.editdialg = true
    },
    handleApproved(type, record) {
      if (type == 'all') {
        this.isoneapproved = false
      } else {
        this.isoneapproved = true
        Object.assign(this.record, record)
      }
      this.approveddialg = true
    },
    showBeef(record) {
      this.visibleBeefList = true
      this.$nextTick(() => {
        this.$refs.beefCattle.querySet(record)
      })
    },
    showBeefCalf(record) {
      this.visibleBeefCalfList = true
      this.$nextTick(() => {
        this.$refs.beefCattleCalf.querySet(record)
      })
    },
    handleCheckBatchNo() {
      // this.checkPost('6')
      this.visibleCheckNo = true
    },
    handleCheckBatchOk() {
      // console.log('handleCheckBatchOk', this.checkUserRows)
      this.checkPost('2')
    },
    checkPut() {
      console.log(typeof this.isApproved)
      putAction1(this.url.isApproved, {
        ids: this.isoneapproved ? [this.record.id] : this.selectedRowKeys,
        isApproved: this.isApproved,
        year: this.queryParam.year
      })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(final => {
          this.visibleCheck = false
          this.loadingTag = false
          this.selectedRowKeys = []
          this.approveddialg = false
          this.visibleCheckNo = false
          this.checkUserRows = []
          this.checkRemark = ''
          this.loadData()
        })
    },
    checkPost(statusing) {
      let ids = []
      this.checkUserRows.forEach(item => {
        ids.push(item.id)
      })

      if (ids.length == 0) {
        this.$message.warning('暂无待审核')
        return
      }
      this.loadingTag = true
      postAction(this.url.batchCheck, { statusing, ids, remark: this.checkRemark })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(final => {
          this.visibleCheck = false
          this.loadingTag = false
          this.visibleCheckNo = false
          this.checkUserRows = []
          this.checkRemark = ''
          this.loadData()
        })
    },
    checkBatch() {
      console.log('checkBatch', this.selectedRowKeys, this.selectionRows)
      this.visibleCheck = true
      this.checkUserRows = []
      this.selectionRows.forEach(item => {
        if ('1' === item.statusing) {
          this.checkUserRows.push(item)
        }
      })
    },
    toPages(record, type) {
      let pageUrl = '/beef/BeefCattleList'
      if (type === 'B') {
        pageUrl = '/beef/smallCattle2'
      }
      //
      // this.$router.go(0)
      this.$router.push(pageUrl + '?userId=' + record.id + '&realname=' + record.realname)
    },
    showModelTag(record) {
      this.tagsUser = record
      // this.tagsUserList = []
      this.visibleTags = true
      this.loadingTag = true
      getAction(this.url.userTagList, { userId: record.id })
        .then(res => {
          // res.result.forEach(item => {
          //   item.tagsNumberStart = (item.tagsNumberStart + '').substring(9, 15)
          //   item.tagsNumberEnd = (item.tagsNumberEnd + '').substring(9, 15)
          // })
          this.tagsUserList = res.result
          console.log(this.url.userTagList, this.tagsUserList)
        })
        .finally(() => {
          this.loadingTag = false
        })
    },
    handleTagOk() {
      //校验
      // if (!this.tagsUserList.length) {
      //   this.$message.warning('暂未输入任何数据')
      //   return
      // }
      let index = 1
      for (let tags of this.tagsUserList) {
        if ((parseInt(tags.tagsNumberStart) + '').length !== 15) {
          this.$message.warning('第' + index + '条，可用耳标编号起，必须是15位纯数字')

          return
        } else if ((parseInt(tags.tagsNumberEnd) + '').length !== 15) {
          this.$message.warning('第' + index + '条，可用耳标编号止，必须是15位纯数字')
          return
        }
        index++
      }
      if (!this.tagsUser.id) {
        this.$message.warning('新增失败')
        return
      }
      //组装提交
      let listTag = []
      for (let tags of this.tagsUserList) {
        let tagsNumberStart = parseInt(tags.tagsNumberStart)
        let tagsNumberEnd = parseInt(tags.tagsNumberEnd)
        if (tagsNumberEnd < tagsNumberStart) {
          let t = tagsNumberStart
          tagsNumberStart = tagsNumberEnd
          tagsNumberEnd = t
        }
        listTag.push({ tagsNumberStart, tagsNumberEnd })
      }
      let modelAdd = { userId: this.tagsUser.id, listTag }
      console.log('新增规则的对象', modelAdd)
      this.loadingTag = true
      postAction(this.url.addBatch, modelAdd)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(fa => {
          this.loadingTag = false
          this.visibleTags = false
          this.tagsUser = ''
          this.tagsUserList = []
        })
    },
    getAvatarView: function(avatar) {
      return getFileAccessHttpUrl(avatar)
    },

    batchFrozen: function(status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return false
      } else {
        let ids = ''
        let that = this
        let isAdmin = false
        that.selectionRows.forEach(function(row) {
          if (row.username == 'admin') {
            isAdmin = true
          }
        })
        if (isAdmin) {
          that.$message.warning('管理员账号不允许此操作,请重新选择！')
          return
        }
        that.selectedRowKeys.forEach(function(val) {
          ids += val + ','
        })
        that.$confirm({
          title: '确认操作',
          content: '是否' + (status == 1 ? '解冻' : '冻结') + '选中账号?',
          onOk: function() {
            frozenBatch({ ids: ids, status: status }).then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          }
        })
      }
    },
    handleMenuClick(e) {
      if (e.key == 1) {
        this.batchDel()
      } else if (e.key == 2) {
        this.batchFrozen(2)
      } else if (e.key == 3) {
        this.batchFrozen(1)
      } else if (e.key == 0) {
        this.checkBatch()
      } else if (e.key == 4) {
        this.handleApproved('all')
      }
    },
    handleFrozen: function(id, status, username) {
      let that = this
      //TODO 后台校验管理员角色
      if ('admin' == username) {
        that.$message.warning('管理员账号不允许此操作！')
        return
      }
      frozenBatch({ ids: id, status: status }).then(res => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username)
    },
    passwordModalOk() {
      //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    },
    onSyncFinally({ isToLocal }) {
      // 同步到本地时刷新下数据
      if (isToLocal) {
        this.loadData()
      }
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
